import { mergeStyleSets } from '@fluentui/react';

export const classNames = mergeStyleSets({
  wrapper: {
    height: '100%',
    padding: '8px 8px 29px',
  },
});
